/**
 * How many words the edit sheet lets a person ADD on one axis — «Слова в
 * описании» and «Не присылать тендеры со словами».
 *
 * Deliberately lower than what the API accepts (`SAVED_SEARCH_TERMS_ACCEPTED_MAX`
 * = 50 in `services/api/.../saved-search-term-limits.ts`): a search that support
 * set up with more words than this must still SAVE — the sheet re-sends the
 * whole list on every edit — so the form only stops offering to add more.
 * While both numbers were 10, every such search answered 400 to any edit.
 *
 * Its own module, not an export of `saved-search-client`: a dozen test files
 * replace that client wholesale with `vi.mock`, and a constant living there
 * would be `undefined` in every one of them.
 */
export const SAVED_SEARCH_TERMS_MAX = 20;

/**
 * How many ИКПУ/CPV codes one saved search may carry — the API's
 * `@ArrayMaxSize(8)` on `ikpuCodes` (create and update DTOs). A request with a
 * ninth code is a 400 «ikpuCodes must contain no more than 8 elements», so
 * whatever ADDS codes to an existing search fills up to this and stops
 * (Spain's company step, negative QA 22.10 Н2).
 */
export const SAVED_SEARCH_CODES_MAX = 8;
